import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { LibSharedCommonModule } from "projects/lib-shared-common/src/public-api";
import { SvcUserAvatarComponent } from "./svc-user-avatar.component";
import { SvcAvatarMultipleComponent } from './svc-avatar-multiple.component';
import { SvcImgModule } from "../svc-img/svc-img.module";

@NgModule({
  imports: [
    LibSharedCommonModule,
    MatTooltipModule,
    MatIconModule,
    SvcImgModule
  ],
  declarations: [
    SvcUserAvatarComponent,
    SvcAvatarMultipleComponent
  ],
  exports: [
    SvcUserAvatarComponent,
    SvcAvatarMultipleComponent
  ],
})
export class SvcUserAvatarModule { }
